import {BaseModel} from '../../_base/crud';

export class TypeOfTitle extends BaseModel {
    id: number;
    name: string;
    created_at: Date;
    updated_at: Date;
    deleted_at: Date;

    deletedBy: string;
    user_deleted: Date;
    userDeletedBy: string;

    clear(): void {
        this.id = undefined;
        this.name = '';
        this.created_at = new Date();
        this.updated_at = new Date();
        this.deleted_at = null;

        this.deletedBy = '';
        this.userDeletedBy = '';
        this.user_deleted = new Date();
        
    }
}
